/* eslint-disable no-shadow */
export enum PasswordAttemptsCaseType {
  ALL_UPPERCASE = 'ALL_UPPERCASE',
  ALL_LOWERCASE = 'ALL_LOWERCASE',
  FIRST_UPPERCASE = 'FIRST_UPPERCASE',
  INVERTED = 'INVERTED',
}

export interface CaseType {
  id: number;
  type: PasswordAttemptsCaseType;
}

export const NextCasesTypesByCase: Record<PasswordAttemptsCaseType, CaseType[]> = {
  [PasswordAttemptsCaseType.ALL_UPPERCASE]: [
    {
      id: 2,
      type: PasswordAttemptsCaseType.ALL_LOWERCASE,
    },
    {
      id: 3,
      type: PasswordAttemptsCaseType.FIRST_UPPERCASE,
    },
  ],
  [PasswordAttemptsCaseType.ALL_LOWERCASE]: [
    {
      id: 2,
      type: PasswordAttemptsCaseType.FIRST_UPPERCASE,
    },
    {
      id: 3,
      type: PasswordAttemptsCaseType.ALL_UPPERCASE,
    },
  ],
  [PasswordAttemptsCaseType.FIRST_UPPERCASE]: [
    {
      id: 2,
      type: PasswordAttemptsCaseType.ALL_LOWERCASE,
    },
    {
      id: 3,
      type: PasswordAttemptsCaseType.ALL_UPPERCASE,
    },
  ],
  [PasswordAttemptsCaseType.INVERTED]: [
    {
      id: 2,
      type: PasswordAttemptsCaseType.INVERTED,
    },
    {
      id: 3,
      type: PasswordAttemptsCaseType.ALL_LOWERCASE,
    },
  ],
};
